import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { pagesCalculator } from './paging-calculate';

import './paging.scss';
import { PagingRecordsCounts } from './_paging-records-counts';

import DoubleChevronLeftSVG from '../../../images/svg/icons8-double-chevron-left';
import DoubleChevronRightSVG from '../../../images/svg/icons8-double-chevron-right';
import Select from '../select/select';
import { PagingViewModel } from './paging-viewmodels/regular-paging.viewmodel';

interface IProps {
    pagingVM: PagingViewModel;
}

const PagingPages = mobxReact.observer((props: IProps) => {
    const { pagingVM: {
        getTotalPages,
        getCurrentPage,
        prev,
        next,
        selectPage
    }} = props;

    const currentPage = getCurrentPage();
    const totalPages = getTotalPages();
    const numbersOfPages = pagesCalculator(totalPages, currentPage);
    const prevButtonClass = 'change-page-btn prev-radius' + (currentPage === 1 || !totalPages ? ' disabled' : '');
    const nextButtonClass = 'change-page-btn next-radius' + (currentPage === totalPages || !totalPages ? ' disabled' : '');

    return <div className='pagination-count'>
        <span className={prevButtonClass} onClick={prev}>{<DoubleChevronLeftSVG />} Prev</span>
        {numbersOfPages.map((item, index) => {
            const pageNumberClass = 'pagination-page-number' + (currentPage === item ? ' current' : '');
            return item !== +item ? <span className='disabled' key={index}>{item}</span>
                : <span className={pageNumberClass} onClick={selectPage.bind(this, item)} key={index}>{item}</span>;
        })}
        <span className={nextButtonClass} onClick={next}>Next {<DoubleChevronRightSVG />}</span>
    </div>;
});

const PageSizeChooser = mobxReact.observer((props: IProps) => {
    const { pagingVM: {
        getPageSize,
        setPageSize,
        getChooserOptions
    }} = props;

    return <Select
        className='page-size-chooser'
        value={getPageSize()}
        onChange={setPageSize}
        options={getChooserOptions()}
        withChevron
    />;
});


const Paging = mobxReact.observer((props: IProps) => {
    const { pagingVM } = props;
    const {
        getTotalPages,
        getCurrentPage,
        getTotalRecords,
        getPageSize,
        withPageSizeChooser
    } = pagingVM;

    const needToShowPagingList = getTotalPages() > 1;
    return (
        <>
            { !needToShowPagingList && withPageSizeChooser && <PageSizeChooser pagingVM={pagingVM} /> }
            { needToShowPagingList && <div className='paging-wrapper'>
                <PagingRecordsCounts
                    currentPage={getCurrentPage()}
                    totalRecords={getTotalRecords()}
                    pageSize={getPageSize()}
                />
                <div className='paging-btns'>
                    { getTotalPages() && needToShowPagingList
                        ? <PagingPages pagingVM={props.pagingVM} />
                        : !needToShowPagingList
                            ? null
                            : '...'}
                    { withPageSizeChooser && <PageSizeChooser pagingVM={pagingVM} /> }
                </div>
            </div>}
        </>
    );
});

export { Paging, PagingPages, PageSizeChooser };